import dayjs from 'dayjs'

/** e.g. `4 Mar 2026`. */
export function formatShortDate(date: string): string {
  return dayjs(date).format('D MMM YYYY')
}
